import styled, { css } from 'styled-components';
import { spacing } from '../constants/spacing.js';
import { px2rem, inPixels } from '../utils/helpers/style.js';
import { Select } from '../Select/Select.web.js';
import { boxStyles } from '../Box/styles.js';
import { selectHeading, icons } from '../Select/styles.js';
import { field, input } from '../InputField/styles.js';
import { container } from '../utils/components/ListItems/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';

var MIN_WIDTH = 290;
var phoneInput = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__phoneInput",
  componentId: "sc-1xpwa8b-0"
})(["--active-color:", ";--inactive-color:", ";--error-color:", ";--phone-input-width:", ";", ";display:flex;flex-direction:row;min-width:", ";width:var(--phone-input-width);", "{", "{border-bottom-left-radius:0;border-top-left-radius:0;border-left-width:0;&:enabled:focus,&:enabled:hover{border-bottom-left-radius:0;border-top-left-radius:0;border-left-width:0;}}}"], function (_ref) {
  var $color = _ref.$color;
  return $color;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.phoneInput.web.inactive;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.phoneInput.web.error;
}, function (_ref4) {
  var width = _ref4.width;
  return width || px2rem(MIN_WIDTH);
}, boxStyles, function (_ref5) {
  var minWidth = _ref5.minWidth;
  return minWidth || px2rem(MIN_WIDTH);
}, field, input);
var select = /*#__PURE__*/styled(Select).withConfig({
  displayName: "styles__select",
  componentId: "sc-1xpwa8b-1"
})(["", "{border-bottom-right-radius:0;border-top-right-radius:0;", "{span{right:", ";}}", ";", ";", "}+ ", "{", "{", ";}}> div:last-of-type{width:var(--phone-input-width);}", "{top:2px;}"], selectHeading, icons, inPixels(spacing.xxxs), function (_ref6) {
  var $error = _ref6.$error,
    $opened = _ref6.$opened;
  return $error && !$opened && "border-right:  ".concat(px2rem(2), " solid var(--error-color);");
}, function (_ref7) {
  var $opened = _ref7.$opened;
  return $opened && "border-bottom: 0px solid var(--inactive-color);";
}, function (_ref8) {
  var $inputFieldFocused = _ref8.$inputFieldFocused,
    $inputFieldHovered = _ref8.$inputFieldHovered,
    $error = _ref8.$error;
  return ($inputFieldFocused || $inputFieldHovered && !$error) && "border-right: ".concat(px2rem(2), " solid var(--active-color);");
}, field, input, function (_ref9) {
  var $opened = _ref9.$opened;
  return $opened && css(["border-bottom:", " solid var(--active-color);border-bottom-right-radius:0;"], px2rem(2));
}, container);

export { phoneInput, select };
